export default "__VITE_ASSET__BQxpmZ98__"